import KPressOnTrigger from '../../../core/utils/KPressOnTrigger'
import { PickerType } from '../constants'
import Button from '../../button'
import Shortcuts from '../views/Shortcuts'

export default {
  inject: ['context'],
  data() {
    return {
      pickerType: PickerType.Date,
      hoveredCell: null,
    }
  },
  computed: {
    value() {
      return this.context.value
    },
    active() {
      return this.context.active
    },
    shortcuts() {
      return this.context.shortcuts || []
    },
    defaultReferenceValue() {
      return this.context.referenceValue
    },
    multiple() {
      return this.context.multiple
    },
  },
  watch: {},
  methods: {
    handleCellHover(cell) {
      this.hoveredCell = cell
    },
    handleCellLeave() {
      this.hoveredCell = null
    },
    renderButton(prev, referenceValueKey) {
      const handler = () => {
        this.$emit(`click-${prev ? 'prev' : 'next'}`, referenceValueKey)
      }

      const events = {
        ...KPressOnTrigger(handler),
      }

      const data = {
        on: events,
      }

      return (
        <Button
          {...data}
          type="light"
          circle={true}
          plain={true}
          icon={prev ? 'chevron-left' : 'chevron-right'}
        >
        </Button>
      )
    },
    renderButtonSkeleton(prev) {
      return (
        <Button
          circle={true}
          plain={true}
          disabled={true}
          icon={prev ? 'chevron-left' : 'chevron-right'}
        >
        </Button>
      )
    },
    renderHeader(referenceValue, { referenceValueKey = 'referenceValue', renderPrev = true, renderNext = true } = {}) {
      referenceValue = referenceValue || this.referenceValue
      const year = referenceValue.year()
      const month = referenceValue.month()

      return (
        <div class="km-date-picker__header">
          {renderPrev ? this.renderButton(true, referenceValueKey) : this.renderButtonSkeleton(true)}
          <div class="km-date-picker__header-center">
            <a class="km-date-picker__header-year">
              {
                year
              }年
            </a>
            <a class="km-date-picker__header-month">
              {
                month + 1
              }月
            </a>
          </div>
          {renderNext ? this.renderButton(false, referenceValueKey) : this.renderButtonSkeleton(false)}
        </div>
      )
    },
    renderShortcuts() {
      return <Shortcuts
        value={this.shortcuts}
      />
    },
  },
}
